import { jsx } from "react/jsx-runtime";
import { LinkFlyout } from "../LinkFlyout/index.js";
import { SystemDefinedLink } from "../SystemDefinedLink/index.js";
import { UserDefinedLink } from "../UserDefinedLink/index.js";
import { SegmentBasedEntry } from "../../Scaffolding/SegmentBasedEntry/SegmentBasedEntry.js";
function LinkListItem({
  dataTestId = "",
  disablePopover,
  insideFlyout = false,
  link,
  linkListStyle,
  locale,
  sx
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (link == null ? void 0 : link.system_defined_link) {
    const linkId = String((_b = (_a = link.system_defined_link) == null ? void 0 : _a.system_link[0]) == null ? void 0 : _b.uid);
    if (!linkId) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      SystemDefinedLink,
      {
        dataTestId,
        entryId: linkId,
        linkStyle: linkListStyle,
        locale
      },
      linkId
    );
  }
  if (link == null ? void 0 : link.user_defined_link) {
    return /* @__PURE__ */ jsx(
      UserDefinedLink,
      {
        disablePopover,
        entry: link.user_defined_link,
        insideFlyout,
        linkListStyle,
        locale,
        sx
      },
      (_c = link.user_defined_link) == null ? void 0 : _c._metadata.uid
    );
  }
  if ((_f = (_e = (_d = link == null ? void 0 : link.segment_based_entry) == null ? void 0 : _d.segment_based_entry) == null ? void 0 : _e[0]) == null ? void 0 : _f.uid) {
    return /* @__PURE__ */ jsx(
      SegmentBasedEntry,
      {
        entryId: (_g = link.segment_based_entry) == null ? void 0 : _g.segment_based_entry[0].uid,
        locale
      }
    );
  }
  if (link == null ? void 0 : link.user_defined_link_with_flyout) {
    return /* @__PURE__ */ jsx(
      LinkFlyout,
      {
        entryId: (_j = (_i = (_h = link.user_defined_link_with_flyout) == null ? void 0 : _h.link_with_flyout) == null ? void 0 : _i[0]) == null ? void 0 : _j.uid,
        locale
      }
    );
  }
}
export {
  LinkListItem
};
